import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import FlexTitleComponent from "../../Trade/Listing/HomepageRevamp4.0/FlexTitle/FlexTitleComponent";
import HeadLines from "../../CommonComponents/HeadLines";
import {
  getPreferenceList,
  updateLangPreference,
} from "../../../../../_services/Arya2.0/Profile";
import { languageOptions as Options } from "../../AccountSettings/LanguageConstant";
import CustomRadioButton from "../../../../../_components/TradeContract/CustomRadioButton/CustomRadioButton";
import HeadLinesSpan from "../../CommonComponents/HeadlinesSpan";
import { isMobile } from "../../helperFunc";
import { eventTracker } from "../../GATracker3.0/eventTracker";
import { LANG_PREFERENCE_CLICKED } from "../../GATracker3.0/constants";
import Button from "../../CommonComponents/Button";
import Loader from "../../CommonComponents/Loader/Loader";
import useUserDetails from "../../CustomHooks/useUserDetails";
import { customToastr } from "../../CustomToastr";

function NotificationPreferredLanguage() {
  const userDetail = useUserDetails();
  const [selectedId, setSelected] = useState(Options[0]);
  const [isLoading, setIsLoading] = useState(false);
  let phone_number = userDetail?.phone_number || userDetail?.phone_number2;

  const getData = async () => {
    setIsLoading(true);
    const res = await getPreferenceList();
    let langPresent = "en";
    if (
      res?.status_code === 200 &&
      res?.data?.users &&
      res?.data?.users?.[0]?.primaryPreferences?.length
    ) {
      res?.data?.users.map((item) => {
        if (phone_number == item?.phoneNumber) {
          item?.primaryPreferences.map((ele) => {
            if (ele?.key === "NOTIFICATION_LANG" && ele?.source === "ARYA_AG") {
              langPresent = ele?.value;
            }
          });
        }
      });

      if (langPresent) {
        Options?.map((ele) => {
          if (ele?.apiValue === langPresent) {
            setSelected(ele);
          }
        });
      } else {
        setSelected(1);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const updatePreferences = async () => {
    eventTracker("event", LANG_PREFERENCE_CLICKED, {
      language: selectedId?.name,
    });
    setIsLoading(true);
    const res = await updateLangPreference(selectedId?.apiValue);
    if (res?.status === "success") {
      customToastr({
        text: "Language updated successfully",
        type: "success",
        timeOut: 3000,
      });
    }
    setIsLoading(false);
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      {!isMobile && (
        <FlexTitleComponent title={"Notification Preferred Language"} />
      )}

      <div
        className={`padding16 boxRadius8 ${style["backGroundImage"]} 
      ${isMobile ? "margin-top30" : "margin-top20"}`}
      >
        <div className={isMobile ? "margin-top16" : ""}>
          <HeadLines
            className={`${
              isMobile
                ? "font-weight600 font-size14 line-height16 margin-bottom16"
                : "font-weight500 font-size24 line-height28 margin-bottom20"
            } letterSpacing05 colorAccent3 `}
            text={"Receive notifications in your preferred language"}
          />
          <div className={`d-flex flex-wrap gap8 margin-bottom8`}>
            {Options.map((option) => {
              return (
                <div
                  className={`d-flex gap8 boxRadius4 margin-bottom8 padding-left8 padding-right8 padding-top4 padding-bottom4 align-items-center ${
                    selectedId.lang_id === option.lang_id
                      ? style["borderSelected"]
                      : style["borderUnSelected"]
                  }`}
                >
                  <CustomRadioButton
                    radioBtnProps={{
                      name: "sms",
                      value: option.name,
                      id: `sms_${option.lang_id}`,
                      checked: selectedId.lang_id === option.lang_id,
                      onChange: (e) => {
                        setSelected(option);
                      },
                    }}
                    tdsRadio={true}
                  />
                  <HeadLines
                    className={`${
                      isMobile
                        ? "font-weight400 font-size12 line-height14"
                        : "font-weight400 font-size14 line-height16"
                    } letterSpacing05 colorDark1`}
                  >
                    {option.language}{" "}
                  </HeadLines>
                </div>
              );
            })}
          </div>
        </div>
        <Button
          title={"Set Preference"}
          onClick={updatePreferences}
          className={
            " d-flex mlr-auto margin-top16 padding-left24 padding-right24 textColorWhite boxRadius6 padding105 backAccent3 font-weight500 font-size16 line-height19"
          }
        />
      </div>
    </div>
  );
}

export default NotificationPreferredLanguage;
